import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      opacity: "0.01",
      x: "0.5",
      width: "24",
      height: "24",
      fill: "#252729"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.402 13.349L18.442 13.276C18.965 12.311 19.275 11.244 19.348 10.148C19.348 8.298 18.598 6.625 17.386 5.412C16.174 4.2 14.5 3.45 12.649 3.45C10.798 3.45 9.12402 4.2 7.91102 5.412C6.69902 6.625 5.94902 8.298 5.94902 10.148C6.01802 11.243 6.32302 12.309 6.84202 13.275C6.84248 13.2757 6.84457 13.279 6.84822 13.2848C6.9159 13.3925 7.52199 14.3564 8.33602 15.549C9.19702 16.814 10.288 18.333 11.203 19.341C11.808 20.015 12.351 20.457 12.649 20.45C13.103 20.463 14.074 19.456 15.054 18.191C16.042 16.927 17.069 15.409 17.733 14.397C18.072 13.881 18.312 13.503 18.409 13.349H18.402ZM12.65 2C17.103 2.112 20.687 5.696 20.799 10.148V10.151V10.153C20.717 11.47 20.348 12.754 19.717 13.914H19.716V13.915L19.654 14.022C19.604 14.111 18.491 15.907 17.189 17.708C14.71 21.194 13.653 21.896 12.649 21.899C12.333 21.901 11.786 21.891 10.728 20.905C9.66702 19.919 8.07602 17.954 5.62702 14.028V14.027L5.62602 14.026L5.56202 13.914V13.913C4.93802 12.753 4.57402 11.468 4.50002 10.152L4.49902 10.15V10.148C4.61102 5.696 8.19502 2.112 12.647 2H12.649H12.65ZM10.4491 9.7C10.4511 10.915 11.4331 11.898 12.6491 11.9C13.8641 11.898 14.8461 10.915 14.8481 9.7C14.8461 8.485 13.8641 7.503 12.6491 7.5C11.4331 7.503 10.4511 8.485 10.4491 9.7ZM8.99912 9.7C8.99912 7.684 10.6321 6.049 12.6491 6.049C14.6651 6.049 16.2991 7.684 16.2991 9.7C16.2991 11.715 14.6651 13.349 12.6491 13.349C10.6321 13.349 8.99912 11.715 8.99912 9.7Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }